import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lp-twofive-twosix-even',
  templateUrl: './lp-twofive-twosix-even.component.html',
  styleUrls: ['./lp-twofive-twosix-even.component.scss']
})
export class LpTwofiveTwosixEvenComponent implements OnInit {

  departments = [
    { id: '1', name: 'DEPARTMENT OF ZOOLOGY' },
    { id: '2', name: 'DEPARTMENT OF ECONOMICS' },
    { id: '3', name: 'DEPARTMENT OF COMMERCE' },
    { id: '4', name: 'DEPARTMENT OF ENGLISH' },
    { id: '5', name: 'DEPARTMENT OF MUSIC' },
    { id: '6', name: 'DEPARTMENT OF HISTORY' },
    { id: '7', name: 'DEPARTMENT OF BOTANY' },
    { id: '8', name: 'DEPARTMENT OF BCA' },
    { id: '9', name: 'DEPARTMENT OF HINDI' },
    { id: '10', name: 'DEPARTMENT OF PHYSICS' },
    { id: '11', name: 'DEPARTMENT OF YOGA' },
    { id: '12', name: 'DEPARTMENT OF B.P.Ed.' },
    { id: '13', name: 'DEPARTMENT OF MATHEMATICS' },
    { id: '14', name: 'DEPARTMENT OF PUBLIC ADMINISTRATION' },
    { id: '15', name: 'DEPARTMENT OF POLITICAL SCIENCE' },
    { id: '16', name: 'DEPARTMENT OF SANSKRIT' },
    { id: '17', name: 'DEPARTMENT OF CHEMISTRY' },
    { id: '18', name: 'DEPARTMENT OF MSW' },
    { id: '19', name: 'DEPARTMENT OF B.Ed.' },
    { id: '20', name: 'DEPARTMENT OF GEOGRAPHY' },
    { id: '21', name: 'DEPARTMENT OF PUNJABI' },
    { id: '22', name: 'DEPARTMENT OF SPORTS' },
    { id: '23', name: 'DEPARTMENT OF BPS' },
    { id: '24', name: 'DEPARTMENT OF BIOTECHNOLOGY' },
    { id: '25', name: 'DEPARTMENT OF IMB' }
  ];

  pdfSrc: string[] = [
    'https://drive.google.com/file/d/1zIpoMkYg5oWMSPO4_JSBU2C2em4zmwN1/preview', // 1. Zoology
    'https://drive.google.com/file/d/1rraUBs7itRY4-yYKLq2BTteWWM6PJd5R/preview', // 2. Economics
    'https://drive.google.com/file/d/1vTx4eH0rLWl3huGHDJV4YNFCHgIcJ6z-/preview', // 3. Commerce
    'https://drive.google.com/file/d/1GfcRa4_dFOziaPCg98OL90T8CpWIkfbd/preview', // 4. English
    'https://drive.google.com/file/d/1rbaCZehaEP7nv2C5LBxDSBC0n0e1WG20/preview', // 5. Music
    'https://drive.google.com/file/d/1TH4sb8jaFqFZieDrNUxrO-PttNBjsR38/preview', // 6. History
    'https://drive.google.com/file/d/1IBQadZzIH5D7FVdHQmGCRmvapwkkHq1q/preview', // 7. Botany
    'https://drive.google.com/file/d/1bIF5cvSec3zT98lS1z5cN9149wBtb9aA/preview', // 8. BCA
    'https://drive.google.com/file/d/14TTzeWQeAQ0tMJqxOTs9IRabKCnc2XVE/preview', // 9. Hindi
    'https://drive.google.com/file/d/1b0TnSHr0coy2WjtzZOq-km1tsq_7pUdV/preview', // 10. Physics
    'https://drive.google.com/file/d/1qo5cjulDpGZQ-2AZezwuvdURQMG6Kke7/preview', // 11. Yoga
    'https://drive.google.com/file/d/1oBe1-lRuCx9T7SHt8cUnOAthFKiHo-d8/preview', // 12. BP ED
    'https://drive.google.com/file/d/1FeDK2XIfidrhmtF_6McxBlXPa5KAm6FL/preview', // 13. Maths
    'https://drive.google.com/file/d/1oALCLJ0Icu3RoTw-h_7_KGiBxJajQLwv/preview', // 14. Public Administration
    'https://drive.google.com/file/d/12DtOg8J41TJAVsUbGkx74KsEMvHk9V0h/preview', // 15. Political Science
    'https://drive.google.com/file/d/1OOuhKbPYNPiJbAJffX57_CK-k5WDAD4u/preview', // 16. Sanskrit
    'https://drive.google.com/file/d/1lhLCtkCEH_q2f1I-csUqKCQcTT86nYw0/preview', // 17. Chemistry
    'https://drive.google.com/file/d/17jrcwJa7QPDe2vERnOiV_9XpaBFKMrTE/preview', // 18. MSW (Social Work)
    'https://drive.google.com/file/d/1tohDYy-lA9ZfK9IoLnrTYo3R1mmVpxlk/preview', // 19. B.Ed.
    'https://drive.google.com/file/d/1d3lW13Y2UZEDeOMaLojoiE3HHX6P0P2Z/preview', // 20. Geography
    'https://drive.google.com/file/d/1LnER-GZUZLBtjFePHIGkYaV4u4TM3Kyz/preview', // 21. Punjabi
    'https://drive.google.com/file/d/1aq5zvSBnB_3s-3RsUm_CG9A3yt2frbTE/preview', // 22. Sports
    'https://drive.google.com/file/d/1BT9oAUHFkZxniZlchQAQU7Bt_P0yhsjp/preview', // 23. BPS
    'https://drive.google.com/file/d/1aeD2A6v61bBTrqXhdYm6DKBMDsWuI5Ek/preview', // 24. Biotechnology
    'https://drive.google.com/file/d/1bFnMzUKLCE7lC9EixaQJR3na5wbjePsu/preview', // 25. IMB
  ];

  src: string;
  isLoading = true;
  activeDepartment: string = '1';
  constructor() { }

  ngOnInit(): void {
    this.changeRoute('1');
  }
  changeRoute(year: string) {
    this.isLoading = true;
    this.activeDepartment = year;
    this.src = this.pdfSrc[parseInt(year) - 1] || ''; // Set the corresponding PDF source
  }
}
